import React from 'react';

import Link from 'gatsby-link';

import Logo from '../assets/logo-full.png';

import PhoneIcon from '../assets/icon/phone.svg';
import PaperIcon from '../assets/icon/paper.svg';
import LetterIcon from '../assets/icon/letter.svg';

const Header = () => (
  <footer className="footer-container">
    <div className="footer-top">
      <div className="container">
        <div className="row align-items-center justify-content-center mt-4">
          <div className="col-10 col-sm-6 col-lg-3 col-xl-3 order-lg-1">
            <img className="img-fluid" src={Logo} alt="Logo Didier Bré — Artisan menuisier" />
          </div>
          <div className="col-12 col-sm-6 col-lg-6 col-xl-3 order-lg-3 mt-5 mt-lg-0 justify-content-center mt-4 text-center text-sm-left">
            <p className="color-red fs-13 bold uppercase ls-17">Adresse</p>
            <p className="color-white fs-12 lh-16">
              <strong className="bold">Didier Bré - Showroom</strong><br />
              17 Avenue d’Argenteuil<br />
               92600 Asnières-sur-seine
            </p>

            <p className="color-white fs-12 lh-16">
              <strong className="bold">Didier Bré - Atelier de fabrication</strong><br />
              1 bis, av. du Capitaine Thuilleaux <br />
              78170 la-Celle-Saint-Cloud
            </p>
          </div>
          <div className="col-12 col-sm-8 col-lg-9 col-xl-3 order-lg-2 justify-content-center mt-5 mt-lg-0 ">
            <p className="color-red fs-13 bold uppercase ls-17">Contactez-nous</p>
            <a className="btn btn-primary btn-outline btn-icon mb-2 w-100" href="tel:0607673616">
              <img src={PhoneIcon} role="presentation" />
              <span>Portable : 06 07 67 36 16</span>
            </a>
            <a className="btn btn-primary btn-outline btn-icon mb-2 w-100" href="tel:0140800843">
              <img src={PaperIcon} role="presentation" />
              <span>Fax : 01 40 80 08 43</span>
            </a>
            <a className="btn btn-primary btn-outline btn-icon mb-2 w-100" href="mailto:contact@menuiseriebre.fr">
              <img src={LetterIcon} role="presentation" />
              <span>contact@menuiseriebre.fr</span>
            </a>
          </div>
          <div className="col-12 col-sm-8 col-lg-6 col-xl-3 order-lg-4 mt-5 justify-content-center mt-5 mt-lg-0">
            <Link to="/projet" className="btn btn-primary btn-block mb-2 mb-lg-0">
              J'ai un projet
            </Link>
            <Link to="/architecte" className="btn btn-light btn-block">
              Je suis architecte
            </Link>
          </div>
        </div>
      </div>
    </div>
    <div className="footer-bottom">
      <div className="container">
        <div className="row align-items-center">
          <div className="col-12 col-lg-6">
            <p className="color-white fs-12 light text-center text-lg-left mb-0">2017 © Didier Bré. Tous droits réservés.</p>
          </div>
          <div className="col-12 col-lg-6 d-flex justify-content-center justify-content-lg-end">
            <ul className="footer-links">
              <li className="footer-links-item ml-3 mr-3 mr-lg-0">
                <Link to="/mentions-legales" className="fs-13 light color-white">
                  Mentions légales
                </Link>
              </li>
              <li className="footer-links-item ml-3 mr-3 mr-lg-0">
                <Link to="/contact" className="fs-13 light color-white">
                  <strong>Contact</strong>
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </footer>
)

export default Header;



// WEBPACK FOOTER //
// ./src/components/footer.js